import React from 'react';

export function ButlerAutomationHead() {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 12.6591C14 13.7225 13.138 14.5845 12.0746 14.5845H1.92539C0.862025 14.5845 0 13.7225 0 12.6591V6.84793C0 5.78457 0.862025 4.92255 1.92539 4.92255H12.0746C13.138 4.92255 14 5.78457 14 6.84793V12.6591ZM5.93141 9.76875C5.93141 10.491 5.34594 11.0764 4.62372 11.0764C3.9015 11.0764 3.31603 10.491 3.31603 9.76875C3.31603 9.04653 3.9015 8.46106 4.62372 8.46106C5.34594 8.46106 5.93141 9.04653 5.93141 9.76875ZM9.39293 11.0764C10.1151 11.0764 10.7006 10.491 10.7006 9.76875C10.7006 9.04653 10.1151 8.46106 9.39293 8.46106C8.67071 8.46106 8.08523 9.04653 8.08523 9.76875C8.08523 10.491 8.67071 11.0764 9.39293 11.0764Z"
        fill="currentColor"
      />
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.00008 0C5.95938 0 5.11572 0.843654 5.11572 1.88435C5.11572 2.68063 5.60962 3.36154 6.30778 3.63747V4.92225L6.30853 4.95484C6.32555 5.32206 6.62866 5.61456 7.00009 5.61456C7.38244 5.61456 7.69239 5.3046 7.69239 4.92225V3.63746C8.39054 3.36153 8.88443 2.68062 8.88443 1.88435C8.88443 0.843654 8.04078 0 7.00008 0ZM7.00945 2.38385C7.28112 2.37885 7.49981 2.15706 7.49981 1.8842C7.49981 1.6082 7.27607 1.38446 7.00007 1.38446C6.72408 1.38446 6.50034 1.6082 6.50034 1.8842C6.50034 2.15707 6.71903 2.37886 6.99071 2.38385C6.99383 2.38381 6.99696 2.38379 7.00009 2.38379C7.00321 2.38379 7.00634 2.38381 7.00945 2.38385Z"
        fill="currentColor"
      />
    </svg>
  );
}
